import React from 'react';
import { JSONTree } from 'react-json-tree';

import type { DevContextProps } from './../../../ricos-context/index.js';
import { DevContext } from './../../../ricos-context/index.js';

import { Button } from '../components/Button.js';
import { jsonTreeTheme } from '../theme.js';

export const RicosRenderingTab: React.FC = () => {
  const devContext = React.useContext(DevContext) as DevContextProps;

  const [renderCounts, setRenderCounts] = React.useState<Map<string, number>>(
    devContext.renderCounts ?? new Map()
  );

  React.useEffect(() => {
    const subscription = devContext.onRenderCountChange?.(renderCounts => {
      setRenderCounts(new Map(renderCounts));
    });

    return () => subscription?.();
  }, [devContext]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => devContext.resetRenderCounts?.()}>Reset counters</Button>
      </div>
      <JSONTree data={renderCounts} invertTheme={false} theme={jsonTreeTheme} hideRoot />
    </div>
  );
};
